(function($) {

  'use strict';

  $('.dw_pb_h1_200px h1').fitText(0.6, { minFontSize: '40px', maxFontSize: '200px' });
  $('.dw_pb_h1_100px h1').fitText(0.8, { minFontSize: '40px', maxFontSize: '100px' });
  $('.dw_pb_h1_80px h1').fitText(0.8, { minFontSize: '40px', maxFontSize: '80px' });

  $('.dw_pb_h2_150px h2').fitText(0.3, { minFontSize: '40px', maxFontSize: '150px' });
  $('.dw_pb_h2_100px h2').fitText(0.8, { minFontSize: '40px', maxFontSize: '100px' });
  $('.dw_pb_h2_70px h2').fitText(0.8, { minFontSize: '35px', maxFontSize: '70px' });
  $('.dw_pb_h2_45px h2').fitText(0.8, { minFontSize: '30px', maxFontSize: '45px' });

  $('.dw_pb_h3_60px h3').fitText(0.8, { minFontSize: '22px', maxFontSize: '60px' });
  $('.dw_pb_h3_50px h3').fitText(0.8, { minFontSize: '22px', maxFontSize: '50px' });
  $('.dw_pb_h3_40px h3').fitText(0.8, { minFontSize: '22px', maxFontSize: '40px' });

  $('.dw_pb_h4_35px h4').fitText(1, { minFontSize: '22px', maxFontSize: '35px' });

  $('.et_pb_wpt_gravityform .gform_title').fitText(0.8, { minFontSize: '35px', maxFontSize: '70px' });

  $('.dw_pb_caption_container').fitText(2, { minFontSize: '14px', maxFontSize: '20px' });

})(jQuery);
